import React, { useMemo } from 'react'
import { Calendar } from '@ow/comps'

// 独有参数currentDate
const Index = ({
  currentDate,
  // fields,
  tbData,
  // config,
  // onChangeSelected,
  // beforeTransform,
  showTbDetail,
  createTbData,
  // destroyTbData,
}) => {
  const transFormDate = (time) => {
    const year = new Date(time).getFullYear()
    const month =
      new Date(time).getMonth() + 1 < 10
        ? `0${new Date(time).getMonth() + 1}`
        : new Date(time).getMonth() + 1
    const day =
      new Date(time).getDate() < 10
        ? `0${new Date(time).getDate()}`
        : new Date(time).getDate()
    return `${year}-${month}-${day}`
  }
  const transFormTime = (time) => {
    const hour =
      new Date(time).getHours() < 10
        ? `0${new Date(time).getHours()}`
        : new Date(time).getHours()
    const minutes =
      new Date(time).getMinutes() < 10
        ? `0${new Date(time).getMinutes()}`
        : new Date(time).getMinutes()
    return `${hour}:${minutes}`
  }

  const data = useMemo(() => {
    return (tbData || []).map((d) => {
      return {
        id: d.objectId,
        date: transFormDate(d.enforcementTime),
        time: transFormTime(d.enforcementTime),
        title: d.lawEnforcementName,
        type: 'info',
        data: d,
      }
    })
  }, [tbData])
  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth() + 1
  const currentDay = new Date().getDate()
  return (
    <Calendar
      currentDate={currentDate}
      allowCreateDate={[`${currentYear}-${currentMonth}-${currentDay}`, null]}
      createEvent={createTbData}
      onEventClick={showTbDetail}
      extData={{ data }}
    />
  )
}

export default Index
